const URL = process.env.REACT_APP_BACKEND_PROD_URL;
// Nginx 프록시 사용 시 URL이 빈 값으로 설정됨 (의도된 동작)
const SAR_URL = process.env.REACT_APP_SAR_HTTP_PROD_URL;
const CMD_EXCEL_URL = process.env.REACT_APP_CMDEXCEL_HTTP_PROD_URL;

const ListOptionSize = [
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 30, label: "30" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const RequestParam = (payload) => {
  const queryParams = Object.entries(payload)
    .map(([key, value]) => {
      if (typeof value === "object") {
        return Object.entries(value)
          .map(([subKey, subValue]) => {
            if (
              subValue !== "" &&
              subValue !== undefined &&
              subValue !== null
            ) {
              return `${subKey}=${subValue}`;
            }
            return "";
          })
          .filter((subQueryParam) => subQueryParam !== "")
          .join("&");
      }
      if (value !== "" && value !== undefined && value !== null) {
        return `${key}=${value}`;
      }
      return "";
    })
    .filter((queryParam) => queryParam !== "")
    .join("&");
  return queryParams;
};

const RenderColor = (value) => {
  const str = parseInt(value);
  if (str <= 30) {
    return "linear-gradient(to right, #ff0000, #ff4444)";
  } else if (str <= 50) {
    return "linear-gradient(to right, #ffc000, #ffd700)";
  } else if (str <= 70) {
    return "linear-gradient(to right, #00b050, #00d060)";
  } else if (str > 70) {
    return "linear-gradient(to right, #2196f3, #64b5f6)";
  }
};

export const UtilRenderColor = (value) => {
  return RenderColor(value)
};

const DateFormat = "YYYY/MM/DD";

// RenderColor 는 UtilRenderColor 를 통해서만 씁니다. 직접 내보내지 않습니다.
export {
  DateFormat, ListOptionSize, RequestParam, URL, SAR_URL, CMD_EXCEL_URL
};

export const keyMapping = {
  host: '호스트',
  stability: '안정성',
  uptimeDays: '가동 일수',
  distribution: '배포판',
  version: 'OS 버전',
  kernel: 'OS 커널',
  hwModel: '하드웨어 모델',
  cpuModel: 'CPU 모델',
  cpuArch: 'CPU 아키텍처',
  cpus: '쓰레드 수',
  cpuUsage: 'CPU 사용량',
  sockets: '소켓 수',
  threadPerCore: '코어당 쓰레드 수',
  corePerSocket: '소켓당 코어 수',
  loadAverage: '평균 부하(1분/5분/15분)',
  memoryDevice: '메모리 모델',
  memorySize: '총 메모리 크기',
  memoryEA: '메모리 개수',
  swapSize: '스왑 크기',
  swapFree: '스왑 여유 공간',
  swapCache: '스왑 캐시',
  memoryUsage: '메모리 사용량',
  diskInfo: '디스크 크기',
  packageCount: '패키지 개수'
};

export const darkPalette = [
  '#40445a',
  '#4c5265',
  '#636363',
  '#606364'
];
